import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ApiClientProvider } from './api/ApiClientProvider';
import { SessionProvider } from './auth/SessionProvider';
import { createApiClient } from './api/client';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

const apiClient = createApiClient();

createRoot(rootEl).render(
  <StrictMode>
    <ApiClientProvider client={apiClient}>
      <SessionProvider client={apiClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SessionProvider>
    </ApiClientProvider>
  </StrictMode>,
);
